import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { HeatMapComponent } from './heat-map/heat-map.component';
import { ScatterPlotComponent } from './scatter-plot/scatter-plot.component';
import { LegendColorScaleComponent } from './legend-color-scale/legend-color-scale.component';
import { BarLineChartComponent } from './bar-line-chart/bar-line-chart.component';


@NgModule({
    imports: [CommonModule, BarChartComponent, HeatMapComponent, ScatterPlotComponent, LegendColorScaleComponent, BarLineChartComponent],
    exports: [BarChartComponent, HeatMapComponent, ScatterPlotComponent, LegendColorScaleComponent, BarLineChartComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class ChartsModule { }
